import { gql } from '@apollo/client'

export default gql(`
    mutation updateDRMLicenseSettings( $apiKey: String $licenseUrl: String ) {
        updateDRMLicenseSettings(
            input: {
                apiKey: $apiKey
                licenseUrl: $licenseUrl
            }
        ) {
            apiKey
            licenseUrl
        }
    }`
)
